export default {
    list: {
        title: "warehouses",
        name: 'warehouses',
        class: "min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center",
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: true,
                name: "Actions",
                buttons: [{
                    text: "add_warehouse",
                    icon: "add",
                    link: '/warehouses/new',
                    color: 'primary'
                }],
            }
        },
        columns: [{
                name: "name",
                elements: [{
                    items: [{
                        class: "",
                        name: "name",
                        type: "text",

                    }, ],
                }, ]
            },
            {
                name: "is_primary",
                class: "text-left",
                elements: [{
                    items: [{
                        class: "",
                        name: "is_primary",
                        type: "text",

                    }, ],
                }, ]
            },
            {
                name: "country",
                elements: [{
                    items: [{
                        class: "",
                        name: "country",
                        type: "text",

                    }, ],
                }, ]
            },
            {
                name: "currency",
                elements: [{
                    items: [{
                        class: "",
                        name: "currency",
                        type: "text",

                    }, ],
                }, ]
            },
            {
                name: "zones",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "zones",
                        type: "text",

                    }, ],
                }, ]
            },
           
        ],
        actions: {
            name: "actions",
            width: "10px",
            class: "justify-center",
            elements: [{
                    icone: "edit",
                    color: "success",
                    role: true,
                    key: 'update',
                    link: '/warehouses/edit',
                    tooltip: "Update",
                },
                {
                    icone: "delete",
                    color: "danger",
                    role: true,
                    key: 'delete',
                    tooltip: "Delete",
                }
            ],
        },
        filters: {
            name: 'warehouses',
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "search_Warehouse",
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    }
                },
                champs: [],
            },
        },
    },
}